module.exports = __webpack_public_path__ + "img/blog_console_sections.7433c1a2.png";